import { usePrefectureDashboardData } from '@/hooks/usePrefectureDashboardData'

const PrefectureRanking = () => {
  const { data, isLoading, error } = usePrefectureDashboardData()

  if (isLoading) {
    return <div className="bg-white p-6 rounded-lg shadow animate-pulse">読み込み中...</div>
  }

  if (error || !data) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <p className="text-red-800">データの読み込みに失敗しました</p>
      </div>
    )
  }

  const { prefectureRanking } = data

  return (
    <div className="bg-white p-6 rounded-lg shadow">
      <h2 className="text-xl font-semibold mb-4">都道府県ランキング</h2>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">順位</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">都道府県</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">優勝回数</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">準優勝回数</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">勝率</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">総試合数</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">勝利</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">敗戦</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">PK勝</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">PK負</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {prefectureRanking.map((item) => (
              <tr key={item.prefectureId}>
                <td className="px-4 py-3 text-sm font-medium text-gray-900">{item.rank}</td>
                <td className="px-4 py-3 text-sm text-gray-900">{item.prefectureName}</td>
                <td className="px-4 py-3 text-sm text-gray-900">{item.totalChampionships}</td>
                <td className="px-4 py-3 text-sm text-gray-900">{item.totalRunnersUp}</td>
                <td className="px-4 py-3 text-sm text-gray-900">{item.winRate.toFixed(1)}%</td>
                <td className="px-4 py-3 text-sm text-gray-900">{item.totalMatches}</td>
                <td className="px-4 py-3 text-sm font-medium text-green-600">{item.totalWins}</td>
                <td className="px-4 py-3 text-sm font-medium text-red-600">{item.totalLosses ?? (item.totalMatches - item.totalWins)}</td>
                <td className="px-4 py-3 text-sm text-gray-900">{item.totalPkWins ?? 0}</td>
                <td className="px-4 py-3 text-sm text-gray-900">{item.totalPkLosses ?? 0}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default PrefectureRanking

